import script from "./home-content-aside-recommend.vue?vue&type=script&lang=ts&setup=true"
export * from "./home-content-aside-recommend.vue?vue&type=script&lang=ts&setup=true"

import "./home-content-aside-recommend.vue?vue&type=style&index=0&id=c1a8fb26&lang=scss"

const __exports__ = script;

export default __exports__